import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";

export class KeyDownManager {
    public static Current:KeyDownManager;
    private pdfDocument:PDFDocument;

    private constructor(pdfDocument:PDFDocument) {
        this.pdfDocument=pdfDocument;

        document.getElementById('DocumentWorkArea').addEventListener('keydown',(e:MouseEvent)=>{
            this.KeyDown((e as any));
        });
    }

    static Initialize(pdfDocument:PDFDocument){
        if(KeyDownManager.Current==null)
            KeyDownManager.Current=new KeyDownManager(pdfDocument);

    }

    private KeyDown(e: any) {
        if(PDFControlBase.SelectedElements==null||PDFControlBase.SelectedElements.length==0)
            return;
        let step=5;
        if(e.ctrlKey)
            step=1;
        let keyCode=e.keyCode;
        switch (keyCode) {
            case 37:
                for(let element of PDFControlBase.SelectedElements)
                {
                    element.MoveTo((element.GetRelativeLeft()-step)+'px',null);
                    e.preventDefault();
                }
                break;
            case 38:
                for(let element of PDFControlBase.SelectedElements)
                {
                    element.MoveTo(null,(element.GetRelativeTop()-step)+'px');
                    e.preventDefault();
                }
                break;
            case 39:
                for(let element of PDFControlBase.SelectedElements)
                {
                    element.MoveTo((element.GetRelativeLeft()+step)+'px',null);
                    e.preventDefault();
                }
                break;
            case 40:
                for(let element of PDFControlBase.SelectedElements)
                {
                    element.MoveTo(null,(element.GetRelativeTop()+step)+'px');
                    e.preventDefault();
                }
                break;

        }
    }
}